import { useState, useEffect, useRef, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLiveData } from '@/hooks/useLiveData';
import { getPublicNews, NewsArticle } from '@/lib/cms';

const ITEMS_PER_PAGE = 6;

const newsItems = [
  {
    id: 12, category: '公司新闻', date: '2026-07-18',
    title: '蚂蚁链控股集团发布「量化驱动资管」核心战略，锚定三大资管板块长期发展路径',
    excerpt: '集团正式明确「量化驱动资管」核心战略定位——以蚂蚁量化为底层策略引擎，以蚂蚁基金、蚂蚁家办、蚂蚁资本为三大资产管理支柱，构建科技驱动型资产管理集团。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20corporate%20strategy%20vision%20roadmap%20with%20glowing%20interconnected%20nodes%20representing%20quantitative%20technology%20flowing%20into%20three%20asset%20management%20pillars%20fund%20management%20family%20office%20capital%20investment%20dark%20navy%20background%20warm%20gold%20and%20amber%20accent%20lines%20professional%20sophisticated%20dark%20fintech%20aesthetic%20visionary%20corporate%20mood%20no%20text%20no%20people&width=600&height=400&seq=news-full-dark-12&orientation=landscape',
  },
  {
    id: 11, category: '公司新闻', date: '2026-07-05',
    title: '香港蚂蚁量化启动海外全球市场，迪拜与泰国双运营总部即将落成挂牌',
    excerpt: '集团正式进军海外市场，迪拜运营中心主体结构封顶、泰国运营中心即将挂牌，标志着蚂蚁链控集团全球化战略布局迈出关键一步。',
    image: 'https://readdy.ai/api/search-image?query=Global%20business%20expansion%20concept%20abstract%20world%20map%20with%20glowing%20connection%20nodes%20between%20Asia%20and%20Middle%20East%20dark%20navy%20background%20gold%20accents%20professional%20corporate%20dark%20fintech%20style%20no%20text&width=600&height=400&seq=news-full-dark-11&orientation=landscape',
  },
  {
    id: 10, category: '公司新闻', date: '2026-07-04',
    title: '香港蚂蚁量化系统组织架构首次公开：覆盖全国的量化服务网络',
    excerpt: '集团首次全面公开「香港蚂蚁量化系统」组织架构，展示从总部到五大区域、七大联合创始人、十八位商学院讲师、三十六位战略委、七十二位分公司老总及一百零八位核心团队长的完整体系。',
    image: 'https://readdy.ai/api/search-image?query=Corporate%20organizational%20structure%20diagram%20visualization%20abstract%20hierarchy%20network%20with%20connected%20nodes%20dark%20navy%20background%20with%20gold%20accents%20professional%20corporate%20style%20clean%20dark%20fintech%20aesthetic%20no%20text&width=600&height=400&seq=news-full-dark-10&orientation=landscape',
  },
  {
    id: 1, category: '公司新闻', date: '2026-06-20',
    title: '蚂蚁链控股集团与中信证券国际达成战略合作，共建跨境量化交易平台',
    excerpt: '双方将在跨境量化策略研发、数据共享与风控技术等领域展开深度合作，共同推动大中华区量化投资生态建设。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20business%20partnership%20visualization%2C%20dark%20navy%20and%20gold%20abstract%20elements%2C%20financial%20data%20overlay%2C%20clean%20sophisticated%20style%2C%20dark%20atmosphere%2C%20no%20text&width=600&height=400&seq=news-full-dark-01&orientation=landscape',
  },
  {
    id: 2, category: '行业洞察', date: '2026-06-15',
    title: '2026年下半年全球宏观展望：利率拐点下的资产配置新范式',
    excerpt: '蚂蚁基金研究团队发布最新宏观研究报告，深入分析美联储政策路径、亚太市场机遇与多资产配置策略。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20global%20macroeconomic%20analysis%2C%20world%20map%20data%20nodes%20in%20dark%20navy%2C%20gold%20accents%2C%20professional%20research%20aesthetic%2C%20dark%20mood%2C%20no%20text&width=600&height=400&seq=news-full-dark-02&orientation=landscape',
  },
  {
    id: 3, category: '合规学习', date: '2026-06-10',
    title: '蚂蚁链控股集团完成SFC第9类牌照年度合规审查',
    excerpt: '集团旗下持牌主体顺利通过香港证监会年度审查，合规管理体系获监管机构高度认可。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20compliance%20regulatory%20visualization%2C%20shield%20pattern%20with%20checkmark%2C%20dark%20navy%20background%2C%20gold%20accents%2C%20trustworthy%20corporate%20mood%2C%20dark%20atmosphere%2C%20no%20text&width=600&height=400&seq=news-full-dark-03&orientation=landscape',
  },
  {
    id: 4, category: '市场研究', date: '2026-06-05',
    title: '量化策略月报：多因子模型在震荡市中的表现与优化',
    excerpt: '蚂蚁量化研究团队发布6月策略月报，回顾各策略线表现，分析因子轮动规律与模型优化方向。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20quantitative%20research%20report%20with%20candlestick%20charts%20and%20data%20analysis%2C%20dark%20navy%20background%2C%20blue%20and%20gold%20geometric%20elements%2C%20professional%20dark%20fintech%20style%2C%20no%20text&width=600&height=400&seq=news-full-dark-04&orientation=landscape',
  },
  {
    id: 5, category: '公告', date: '2026-05-28',
    title: '关于蚂蚁链控股集团官方网站全新上线的公告',
    excerpt: '为更好展示集团品牌形象与业务体系，集团官方网站于2026年5月完成全面升级，正式上线运营。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20website%20launch%20announcement%2C%20abstract%20digital%20network%2C%20dark%20navy%20background%2C%20gold%20accent%20elements%2C%20clean%20sophisticated%20dark%20corporate%20style%2C%20no%20text&width=600&height=400&seq=news-full-dark-05&orientation=landscape',
  },
  {
    id: 6, category: '公司新闻', date: '2026-05-20',
    title: '蚂蚁家办成功举办"家族财富传承与跨境税务规划"高端闭门研讨会',
    excerpt: '来自香港、新加坡与内地的多位家族办公室负责人及税务专家齐聚一堂，深入探讨跨境财富传承新趋势。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20seminar%20and%20conference%20scene%2C%20sophisticated%20dark%20venue%20atmosphere%2C%20dark%20navy%20and%20gold%20theme%2C%20professional%20abstract%20representation%2C%20dark%20mood%2C%20no%20text&width=600&height=400&seq=news-full-dark-06&orientation=landscape',
  },
  {
    id: 7, category: '行业洞察', date: '2026-05-15',
    title: '区块链技术在资产管理领域的应用前景与合规挑战',
    excerpt: '蚂蚁链控集团研究团队发布专题报告，系统梳理区块链技术在资产代币化、智能合约与合规监管领域的应用现状。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20blockchain%20network%20visualization%2C%20interconnected%20nodes%20and%20chains%2C%20dark%20navy%20background%2C%20blue%20and%20gold%20geometric%20elements%2C%20futuristic%20dark%20fintech%20style%2C%20no%20text&width=600&height=400&seq=news-full-dark-07&orientation=landscape',
  },
  {
    id: 8, category: '合规学习', date: '2026-05-08',
    title: '香港证监会最新《基金经理操守准则》修订要点解读',
    excerpt: '集团合规团队发布政策解读，梳理SFC最新修订对资产管理公司运营与合规管理的具体影响与应对措施。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20legal%20document%20review%20visualization%2C%20regulatory%20compliance%20theme%2C%20dark%20navy%20background%2C%20clean%20dark%20corporate%20style%2C%20abstract%20representation%2C%20no%20text&width=600&height=400&seq=news-full-dark-08&orientation=landscape',
  },
  {
    id: 9, category: '市场研究', date: '2026-04-28',
    title: '亚太区家族办公室发展趋势：从财富保值到影响力投资',
    excerpt: '蚂蚁家办研究院发布年度白皮书，深入分析亚太区家族办公室在资产配置、治理结构与ESG投资领域的演变趋势。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20family%20office%20wealth%20management%20trend%20report%2C%20dark%20navy%20background%2C%20golden%20heritage%20symbolism%2C%20sophisticated%20dark%20corporate%20style%2C%20no%20text&width=600&height=400&seq=news-full-dark-09&orientation=landscape',
  },
];

export default function News() {
  const [activeCategory, setActiveCategory] = useState('全部');
  const [currentPage, setCurrentPage] = useState(1);
  const [cmsNews, setCmsNews] = useState<NewsArticle[] | null>(null);
  const filterSectionRef = useRef<HTMLDivElement>(null);
  const gridRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const items = cmsNews?.length ? cmsNews : newsItems;
  const dynamicCategories = useMemo(
    () => ['全部', ...Array.from(new Set(items.map((item) => item.category)))],
    [items],
  );

  useEffect(() => {
    let mounted = true;
    getPublicNews()
      .then((res) => {
        if (mounted) setCmsNews(res.items);
      })
      .catch(() => {
        if (mounted) setCmsNews(null);
      });
    return () => { mounted = false; };
  }, []);

  const filtered = useMemo(
    () => activeCategory === '全部' ? items : items.filter((n) => n.category === activeCategory),
    [activeCategory, items]
  );

  const totalPages = Math.max(1, Math.ceil(filtered.length / ITEMS_PER_PAGE));
  const paginatedItems = useMemo(
    () => filtered.slice((currentPage - 1) * ITEMS_PER_PAGE, currentPage * ITEMS_PER_PAGE),
    [filtered, currentPage]
  );

  // Reset to page 1 when category changes
  useEffect(() => { setCurrentPage(1); }, [activeCategory]);

  const handlePageChange = (page: number) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleCategoryBadgeClick = (category: string) => {
    setActiveCategory(category);
    if (filterSectionRef.current) {
      filterSectionRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const handleCardClick = (id: number) => {
    navigate(`/news/${id}`);
  };

  return (
    <div className="min-h-screen bg-background-50">
      {/* Page Header */}
      <section className="relative pt-32 pb-16 md:pt-40 md:pb-20 bg-background-50 overflow-hidden">
        <div className="absolute inset-0 bg-dot-matrix opacity-25"></div>
        <div className="relative px-6 md:px-12 lg:px-20">
          <div className="max-w-[1400px] mx-auto">
            <p className="text-accent-500 text-xs md:text-sm font-semibold tracking-[0.25em] uppercase mb-4">News &amp; Insights</p>
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-100 leading-tight">新闻动态</h1>
            <p className="mt-4 text-sm md:text-base text-foreground-400 max-w-2xl leading-relaxed font-light">
              了解集团最新动态、行业前沿洞察与合规学习资源
            </p>

            {/* Compact news ticker */}
            <div className="mt-6 overflow-hidden rounded-lg bg-background-100/60 border border-background-300/20 py-2.5 px-4">
              <div className="flex items-center gap-3 overflow-hidden">
                <span className="flex items-center gap-1.5 flex-shrink-0">
                  <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse-glow"></span>
                  <span className="text-[10px] mono-data text-emerald-400 font-semibold tracking-wider">BREAKING</span>
                </span>
                <div className="overflow-hidden flex-1">
                  <div className="news-ticker-compact">
                    <span className="text-xs text-foreground-400 whitespace-nowrap mr-12 font-light">
                      「量化驱动资管」核心战略正式发布，锚定三大资管板块长期路径 ｜ 香港蚂蚁量化启动海外全球市场，迪拜与泰国双运营总部即将落成挂牌 ｜ 香港蚂蚁量化系统组织架构首次公开：覆盖全国的量化服务网络 ｜ 2026年下半年全球宏观展望报告发布 ｜ 集团SFC第9类牌照年度合规审查顺利通过 ｜ 量化策略6月月报：多因子模型优化成果
                    </span>
                    <span className="text-xs text-foreground-400 whitespace-nowrap mr-12 font-light">
                      「量化驱动资管」核心战略正式发布，锚定三大资管板块长期路径 ｜ 香港蚂蚁量化启动海外全球市场，迪拜与泰国双运营总部即将落成挂牌 ｜ 香港蚂蚁量化系统组织架构首次公开：覆盖全国的量化服务网络 ｜ 2026年下半年全球宏观展望报告发布 ｜ 集团SFC第9类牌照年度合规审查顺利通过 ｜ 量化策略6月月报：多因子模型优化成果
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Category Filter */}
      <section className="py-6 bg-background-50 border-b border-background-300/30 sticky top-16 z-40 backdrop-blur-xl bg-background-50/90" ref={filterSectionRef}>
        <div className="px-6 md:px-12 lg:px-20">
          <div className="max-w-[1400px] mx-auto">
            <div className="flex flex-wrap items-center gap-2">
              {dynamicCategories.map((cat) => (
                <button
                  key={cat}
                  onClick={() => setActiveCategory(cat)}
                  className={`px-4 py-2 rounded-full text-xs md:text-sm font-medium whitespace-nowrap transition-all duration-300 cursor-pointer ${
                    cat === activeCategory
                      ? 'bg-accent-500 text-background-950 shadow-[0_0_15px_rgba(200,160,80,0.2)]'
                      : 'bg-background-100 text-foreground-500 hover:text-foreground-200 border border-background-300/30 hover:border-background-400/50'
                  }`}
                >
                  {cat}
                  <span className={`ml-1.5 text-[10px] mono-data tabular-nums ${cat === activeCategory ? 'text-background-950/60' : 'text-foreground-600'}`}>
                    {cat === '全部' ? items.length : items.filter((n) => n.category === cat).length}
                  </span>
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* News Grid */}
      <section className="py-16 md:py-24 bg-background-50">
        <div className="px-6 md:px-12 lg:px-20">
          <div className="max-w-[1400px] mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-7" ref={gridRef}>
              {paginatedItems.map((item) => (
                <NewsCard key={item.id} item={item} onCategoryClick={handleCategoryBadgeClick} onCardClick={handleCardClick} />
              ))}
            </div>

            {/* Pagination */}
            <div className="flex items-center justify-center gap-2 mt-14">
              <button
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
                className="w-10 h-10 rounded-lg border border-background-300/30 flex items-center justify-center text-foreground-500 hover:border-accent-500/30 hover:text-accent-500 transition-all duration-200 cursor-pointer disabled:opacity-30 disabled:cursor-not-allowed disabled:hover:border-background-300/30 disabled:hover:text-foreground-500"
              >
                <i className="ri-arrow-left-s-line"></i>
              </button>
              {Array.from({ length: totalPages }, (_, i) => i + 1).map((p) => (
                <button
                  key={p}
                  onClick={() => handlePageChange(p)}
                  className={`w-10 h-10 rounded-lg text-sm font-medium transition-all duration-200 cursor-pointer ${
                    p === currentPage
                      ? 'bg-accent-500 text-background-950 shadow-[0_0_15px_rgba(200,160,80,0.2)]'
                      : 'border border-background-300/30 text-foreground-500 hover:border-accent-500/30 hover:text-foreground-200'
                  }`}
                >
                  {p}
                </button>
              ))}
              <button
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                className="w-10 h-10 rounded-lg border border-background-300/30 flex items-center justify-center text-foreground-500 hover:border-accent-500/30 hover:text-accent-500 transition-all duration-200 cursor-pointer disabled:opacity-30 disabled:cursor-not-allowed disabled:hover:border-background-300/30 disabled:hover:text-foreground-500"
              >
                <i className="ri-arrow-right-s-line"></i>
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

/* ── News Card with Live View Count ── */
function NewsCard({ item, onCategoryClick, onCardClick }: { item: { id: number; category: string; date: string; title: string; excerpt: string; image: string }; onCategoryClick: (category: string) => void; onCardClick: (id: number) => void }) {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setVisible(true); }, { threshold: 0.3 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  const baseViews = (item.id * 173 + 420) % 2800 + 200;
  const { formatted: viewCount, flash } = useLiveData({
    initial: baseViews,
    range: 12,
    decimals: 0,
    interval: 4000 + item.id * 400,
  });

  return (
    <article
      ref={ref}
      onClick={() => onCardClick(item.id)}
      className="group bg-background-100 rounded-xl border border-background-300/30 overflow-hidden hover:border-accent-500/30 hover:-translate-y-1 transition-all duration-300 cursor-pointer"
    >
      <div className="relative h-48 overflow-hidden">
        <img
          src={item.image}
          alt={item.title}
          className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-100 via-transparent to-transparent"></div>
        <div className="absolute top-3 left-3">
          <button
            onClick={(e) => { e.stopPropagation(); onCategoryClick(item.category); }}
            className="px-2.5 py-1 bg-background-100/85 backdrop-blur-sm rounded-full text-[10px] md:text-xs font-semibold text-primary-400 border border-background-300/30 hover:border-accent-500/50 hover:text-accent-400 hover:bg-background-100 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            {item.category}
          </button>
        </div>
        {/* Live view badge */}
        <div className="absolute top-3 right-3 flex items-center gap-1 px-2 py-0.5 rounded-full bg-background-100/70 backdrop-blur-sm border border-background-300/30">
          <span className="w-1 h-1 rounded-full bg-accent-400/60 view-count-shimmer"></span>
          <span className={`text-[9px] mono-data font-semibold tabular-nums transition-colors duration-300 ${flash ? 'text-accent-400' : 'text-foreground-500'}`}>
            {visible ? viewCount : '---'}
          </span>
        </div>
      </div>
      <div className="p-5">
        <p className="text-[10px] md:text-xs text-foreground-600 mb-2">{item.date}</p>
        <h3 className="text-sm md:text-base font-semibold text-foreground-200 leading-snug mb-2 group-hover:text-accent-400 transition-colors duration-200 line-clamp-2">
          {item.title}
        </h3>
        <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 font-light">
          {item.excerpt}
        </p>
      </div>
    </article>
  );
}
